/* Purchases. A line says what it is missing in words and in grouped kinds; colour never carries a
   meaning alone (ADR-0007), and no emission, multiplier or price appears anywhere on it. */

.list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.line {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 11px 0;
  border-bottom: 1px solid var(--line);
}

.head {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.vendor {
  font-size: var(--t-dense);
  font-weight: 650;
  color: var(--ink);
}

.amount {
  font-family: var(--mono);
  font-size: var(--t-dense);
  color: var(--ink);
  white-space: nowrap;
}

.meta,
.description {
  font-size: var(--t-min);
  color: var(--muted);
}

.description {
  color: var(--ink-2);
}

/* The statement of absence. A pill with words in it, not a dash and not a zero. */
.nofigure {
  align-self: flex-start;
  padding: 2px 8px;
  border: 1px solid var(--line-2);
  border-radius: 999px;
  font-size: var(--t-min);
  font-weight: 650;
  color: var(--ink-2);
}

.reasons,
.items {
  margin: 0;
  padding: 0;
  list-style: none;
}

.reasons {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: var(--t-min);
  color: var(--ink-2);
  line-height: 1.5;
}

.items {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding-left: 12px;
  border-left: 2px solid var(--line-2);
}

.published {
  padding: 7px 9px;
  border-left: 2px solid var(--accent);
  background: var(--panel-2);
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--ink-2);
}

.form {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.preview {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.problems {
  margin: 0;
  padding-left: 16px;
  line-height: 1.5;
}

.repeat,
.unauthorized {
  margin: 0;
  padding: 9px 11px;
  border: 1px solid var(--warn-line);
  border-radius: 7px;
  background: var(--warn-w);
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--ink-2);
}
